document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded',()=>{
  const body=document.body;
  const header=document.querySelector('[data-tt-header]')||document.querySelector('.tt-header');
  const menuBtn=document.querySelector('[data-tt-menu]');
  const mobile=document.querySelector('[data-tt-mobile]');

  if(menuBtn&&mobile){
    const closeMenu=()=>{
      mobile.classList.remove('open');
      mobile.setAttribute('aria-hidden','true');
      menuBtn.setAttribute('aria-expanded','false');
      menuBtn.setAttribute('aria-label','Otvori meni');
      body.classList.remove('lock');
      body.classList.remove('tt-mobile-menu-open');
    };
    const openMenu=()=>{
      mobile.classList.add('open');
      mobile.setAttribute('aria-hidden','false');
      menuBtn.setAttribute('aria-expanded','true');
      menuBtn.setAttribute('aria-label','Zatvori meni');
      body.classList.add('lock');
      body.classList.add('tt-mobile-menu-open');
      if(header)header.classList.remove('tt-header--hidden');
    };
    menuBtn.addEventListener('click',()=>mobile.classList.contains('open')?closeMenu():openMenu());
    document.querySelectorAll('[data-tt-mobile-close]').forEach(button=>button.addEventListener('click',closeMenu));
    mobile.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&mobile.classList.contains('open'))closeMenu();});
    window.addEventListener('resize',()=>{if(window.innerWidth>1120&&mobile.classList.contains('open'))closeMenu();},{passive:true});
  }

  if(header){
    const phoneQuery=window.matchMedia('(max-width:760px)');
    const getScrollTop=()=>Math.max(
      window.pageYOffset||0,
      window.scrollY||0,
      document.documentElement?.scrollTop||0,
      document.body?.scrollTop||0
    );

    let lastScroll=getScrollTop();
    let accumulatedUp=0;
    let accumulatedDown=0;
    let ticking=false;
    let touchStartY=null;

    const showHeader=()=>header.classList.remove('tt-header--hidden');
    const hideHeader=()=>{
      if(!(mobile&&mobile.classList.contains('open')))header.classList.add('tt-header--hidden');
    };

    const updateHeader=()=>{
      const current=getScrollTop();
      const delta=current-lastScroll;
      const menuOpen=mobile&&mobile.classList.contains('open');

      header.classList.toggle('tt-header--compact',current>20);

      if(!phoneQuery.matches){
        showHeader();
        accumulatedUp=0;
        accumulatedDown=0;
      }else if(menuOpen||current<24){
        showHeader();
        accumulatedUp=0;
        accumulatedDown=0;
      }else if(delta<0){
        accumulatedUp+=Math.abs(delta);
        accumulatedDown=0;
        /* A very small upward movement must reveal the menu immediately. */
        if(accumulatedUp>=4)showHeader();
      }else if(delta>0){
        accumulatedDown+=delta;
        accumulatedUp=0;
        /* Keep the header visible near the top, then hide it on a clear downward scroll. */
        if(current>110&&accumulatedDown>=18)hideHeader();
      }

      lastScroll=current;
      ticking=false;
    };

    const requestHeaderUpdate=()=>{
      if(!ticking){
        window.requestAnimationFrame(updateHeader);
        ticking=true;
      }
    };

    window.addEventListener('scroll',requestHeaderUpdate,{passive:true});
    document.addEventListener('scroll',requestHeaderUpdate,{passive:true,capture:true});

    /* Touch-direction fallback for mobile browsers and Shopify's preview iframe. */
    document.addEventListener('touchstart',event=>{
      touchStartY=event.touches&&event.touches[0]?event.touches[0].clientY:null;
    },{passive:true});
    document.addEventListener('touchmove',event=>{
      if(!phoneQuery.matches||touchStartY===null||!event.touches||!event.touches[0])return;
      const currentY=event.touches[0].clientY;
      const fingerDelta=currentY-touchStartY;
      if(fingerDelta>7){
        showHeader();
      }else if(fingerDelta<-14&&getScrollTop()>110&&!(mobile&&mobile.classList.contains('open'))){
        hideHeader();
      }
      touchStartY=currentY;
    },{passive:true});
    document.addEventListener('touchend',()=>{touchStartY=null;},{passive:true});

    window.addEventListener('resize',()=>{
      lastScroll=getScrollTop();
      accumulatedUp=0;
      accumulatedDown=0;
      showHeader();
      requestHeaderUpdate();
    },{passive:true});
    window.addEventListener('pageshow',()=>{
      lastScroll=getScrollTop();
      showHeader();
      requestHeaderUpdate();
    });
    document.addEventListener('visibilitychange',()=>{
      if(!document.hidden){
        lastScroll=getScrollTop();
        showHeader();
      }
    });

    updateHeader();
  }

  document.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{const target=document.querySelector(link.getAttribute('href'));if(target){event.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}}));

  const revealItems=document.querySelectorAll('.tt-reveal');
  if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -40px'});revealItems.forEach(item=>observer.observe(item));}else revealItems.forEach(item=>item.classList.add('is-visible'));

  const navLinks=[...document.querySelectorAll('.tt-nav a[href^="#"]')];
  if('IntersectionObserver'in window&&navLinks.length){const sections=navLinks.map(link=>document.querySelector(link.getAttribute('href'))).filter(Boolean);const navObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){navLinks.forEach(l=>l.classList.toggle('is-active',l.getAttribute('href')===`#${entry.target.id}`));}});},{rootMargin:'-30% 0px -60% 0px'});sections.forEach(section=>navObserver.observe(section));}

  const modal=document.querySelector('[data-tt-contact-modal]');
  const triggers=document.querySelectorAll('[data-tt-contact-picker]');
  let lastTrigger=null;
  const openModal=trigger=>{if(!modal)return;lastTrigger=trigger;modal.hidden=false;requestAnimationFrame(()=>modal.classList.add('is-open'));body.classList.add('lock');setTimeout(()=>modal.querySelector('.tt-contact-choice-card a')?.focus(),80);};
  const closeModal=()=>{if(!modal)return;modal.classList.remove('is-open');setTimeout(()=>modal.hidden=true,180);body.classList.remove('lock');lastTrigger?.focus();};
  triggers.forEach(btn=>btn.addEventListener('click',()=>openModal(btn)));
  modal?.querySelectorAll('[data-tt-contact-close]').forEach(btn=>btn.addEventListener('click',closeModal));
  modal?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{modal.classList.remove('is-open');setTimeout(()=>modal.hidden=true,180);body.classList.remove('lock');}));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&modal&&!modal.hidden)closeModal();});

  const formRoot=document.querySelector('[data-tt-enquiry-form]');
  const form=formRoot?formRoot.querySelector('form'):null;
  const storageKey='tandemEnquiryDraftV22',recipientKey='tandemWaRecipientV22',redirectKey='tandemWaRedirectAfterSubmitV22';
  const loadJson=key=>{try{return JSON.parse(localStorage.getItem(key)||'{}');}catch(e){return {};}};
  const saveJson=(key,value)=>{try{localStorage.setItem(key,JSON.stringify(value));}catch(e){}};
  const readForm=()=>{if(!form)return{};const value=key=>{const field=form.querySelector(`[data-tt-field="${key}"]`);return field&&field.value?field.value.trim():'';};return{name:value('name'),phone:value('phone'),email:value('email'),request:value('request'),intake:value('intake'),location:value('location'),body:value('body')};};
  const selectedRecipient=()=>{const selected=form?.querySelector('[data-tt-wa-choice]:checked');return selected?{number:selected.dataset.ttWaNumber||'',name:selected.dataset.ttWaName||''}:loadJson(recipientKey);};
  const buildMessage=data=>{const lines=['Pozdrav, upravo sam poslao/la upit preko TANDEM² sajta.'];if(data.name)lines.push(`Ime / firma: ${data.name}`);if(data.phone)lines.push(`Telefon: ${data.phone}`);if(data.request)lines.push(`Vrsta zahteva: ${data.request}`);if(data.intake)lines.push(`Način prijema: ${data.intake}`);if(data.location)lines.push(`Lokacija mašine: ${data.location}`);if(data.body)lines.push(`Kratak opis: ${data.body}`);lines.push('U nastavku dodajem fotografiju pločice i fotografiju dela ili problema.');return lines.join('\n');};
  const waUrl=(number,data)=>number?`https://wa.me/${number}?text=${encodeURIComponent(buildMessage(data))}`:'';
  if(form){form.addEventListener('submit',()=>{saveJson(storageKey,readForm());saveJson(recipientKey,selectedRecipient());try{sessionStorage.setItem(redirectKey,'1');}catch(e){}});}
  const success=document.querySelector('.tt-form-success');let shouldRedirect=false;try{shouldRedirect=sessionStorage.getItem(redirectKey)==='1';}catch(e){}
  if(success&&shouldRedirect){try{sessionStorage.removeItem(redirectKey);}catch(e){}const data=loadJson(storageKey),recipient=loadJson(recipientKey),url=waUrl(recipient.number,data);if(url)setTimeout(()=>window.location.replace(url),500);}
});
